export default __webpack_public_path__ + "static/media/icon-download.b74c3750.svg";